import { Star } from 'lucide-react';
import { testimonials } from '../../data/mock';
import { useInView } from '../../hooks/useInView';

export const Testimonials = () => {
  const [ref, isInView] = useInView();

  return (
    <section className="section-gap bg-obsidian-light relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_rgba(200,149,109,0.015)_0%,_transparent_60%)]" />

      <div ref={ref} className="relative max-w-6xl mx-auto">
        {/* Header */}
        <div
          className={`text-center mb-20 transition-all duration-900 ${
          isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`
          }>

          <div className="flex items-center justify-center gap-4 mb-5">
            <div className="w-8 h-px bg-amber/20" />
            <span className="font-body text-[11px] tracking-[0.4em] uppercase text-amber/50">
              Voices
            </span>
            <div className="w-8 h-px bg-amber/20" />
          </div>
          <h2 className="font-heading text-[2.5rem] md:text-[3.5rem] font-light text-ivory">
            Memories That <em className="italic text-amber">Last</em>
          </h2>
        </div>

        {/* Testimonials - editorial layout */}
        <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
          {testimonials.map((t, index) =>
          <div
            key={t.id}
            className={`border border-amber/[0.06] rounded-sm p-8 lg:p-10 card-premium ${
            isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`
            }
            style={{ transitionProperty: 'opacity, transform, border-color', transitionDuration: '0.8s', transitionTimingFunction: 'cubic-bezier(0.16, 1, 0.3, 1)', transitionDelay: isInView ? `${index * 120 + 200}ms` : '0ms' }}>

              {/* Stars */}
              <div className="flex gap-1 mb-6">
                {Array.from({ length: t.rating }).map((_, i) =>
              <Star key={i} size={11} className="text-amber/40 fill-amber/40" />
              )}
              </div>

              {/* Quote */}
              <blockquote className="font-heading md:text-[1.3rem] !font-light !leading-[1.6rem] !italic mb-8 text-[1.15rem] text-ivory/50">
                “{t.text}”
              </blockquote>

              {/* Author */}
              <div className="flex items-center gap-3">
                <div className="w-8 h-px bg-amber/15" />
                <div>
                  <p className="font-body text-[13px] font-medium text-ivory/60">{t.name}</p>
                  <p className="font-body text-[11px] text-ivory/20">{t.location}</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>);

};